import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import TextInput from '../../../../shared/Inputs/TextInput/TextInput'
import DatePicker from '../../../../shared/Inputs/DatePicker/DatePicker'
import { UPLOADS_ENDPOINT } from '../../../../server-parameters'
import { yearsAgo } from '../../../../utils/helpers'
import {
  validateName,
  validateDate,
  passportDigits,
  passportText,
  smartValidateString,
} from '../../../../validate/validators'
import { Country, Lang } from '../../../../types/common-types'
import { State } from '../../../../state-actions-reducers'
import FileInput from '../../../../shared/Inputs/FileInput/FileInput'
import IdentityExist from '../../../../components/IdentityExist/IdentityExist'

export default function KazakhstanForm({
  lang,
  accountForm,
}: { lang: Lang; accountForm: any }) {
  const { watch, setValue, getValues, formState: { errors } } = useFormContext<State>()
  const state = watch()
  const [focus, setFocus] = useState('')
  return (
    <>
      <div className="col-4 col-xs-12">
        {/* PASSPORT_CARD_NUMBER */}
        <TextInput
          testName="passportCardNumber"
          testErrorName="error-passportCardNumber"
          disabled={!state.agreed}
          lang={lang}
          content={accountForm.passportUdvNumber}
          onChange={passportCardNumber => {
            setValue('passportCardNumber', passportCardNumber, { shouldDirty: true })
          }}
          value={state.passportCardNumber}
          required
          valid={
            validateName(state.passportCardNumber, false) &&
            !errors.passportCardNumber
          }
          onBlur={() => setFocus('')}
          mask={'999999999'}
        />
      </div>
      <IdentityExist
            accountForm={accountForm}
            lang={lang}
            show={!state.isIdentityOk}
          />
      <div className="col-8 col-xs-12">
        {/* PASSPORT ISSUED BY */}
        <TextInput
          testName="passportIssuedBy"
          testErrorName="error-passportIssuedBy"
          disabled={!state.agreed}
          lang={lang}
          content={accountForm.issuedBy}
          onChange={passportIssuedBy =>
            setValue('passportIssuedBy', passportIssuedBy.toLocaleUpperCase(), { shouldDirty: true })
          }
          value={state.passportIssuedBy}
          required
          valid={
            state.passportIssuedBy.length > 0
              ? smartValidateString(state.passportIssuedBy) &&
                !errors.passportIssuedBy
              : !errors.passportIssuedBy
          }
          onBlur={() => setFocus('')}
        />
      </div>
      <div className="col-2 col-xs-12">
        {/* PASSPORT ISSUE DATE */}
        <DatePicker
          testName="passportIAt"
          testErrorName="error-passportIAt"
          disabled={!state.agreed}
          lang={lang}
          accountForm={accountForm}
          accountFormKey="passportIAt"
          onChange={data => setValue('passportIAt', data, { shouldDirty: true })}
          value={state.passportIAt}
          required
          valid={!errors.passportIAt}
          onBlur={() => setFocus('')}
          curr={new Date()}
          min={new Date(new Date().setFullYear(new Date().getFullYear() - 10))}
          max={new Date()}
        />
      </div>
      <div className="col-3 col-xs-12">
        {/* PASSPORT EXPIRY DATE */}
        <DatePicker
          testName="passportExpiryDate"
          testErrorName="error-passportExpiryDate"
          disabled={!state.agreed}
          lang={lang}
          accountForm={accountForm}
          accountFormKey="passportExpiryDate"
          onChange={data =>
            setValue('passportExpiryDate', data, { shouldDirty: true })
          }
          value={state.passportExpiryDate}
          required
          valid={!errors.passportExpiryDate}
          onBlur={() => setFocus('')}
          min={new Date()}
          max={new Date(new Date().setFullYear(new Date().getFullYear() + 10))}
        />
      </div>
      <div className="col-4 col-xs-12">
        {/* PASSPORT_PERSON_NUMBER */}
        <TextInput
          testName="passportPersonNumber"
          testErrorName="error-passportPersonNumber"
          disabled={!state.agreed}
          lang={lang}
          content={accountForm.passportIinNumberRequired}
          onChange={passportPersonNumber => {
            setValue('passportPersonNumber', passportPersonNumber, { shouldDirty: true })
          }}
          value={state.passportPersonNumber}
          required
          valid={!errors.passportPersonNumber}
          onBlur={() => setFocus('')}
          mask={'999999999999'}
        />
      </div>
      <div className="col-4 col-xs-12">
        <FileInput
          testName="mainImageFile"
          testErrorName="error-mainImageFile"
          disabled={!state.agreed}
          lang={lang}
          url={UPLOADS_ENDPOINT}
          autorization={state.formId}
          target={state.passportImages}
          content={accountForm.udvFile}
          
          onChange={mainImageFile => {
            setValue('mainImageFile', mainImageFile, { shouldDirty: true })
          }}
          value={state.mainImageFile[state.mainImageFile.length - 1]}
          valid={!errors.mainImageFile}
          documentType="Passport1"
          imageErrors={state.imageError}
        />
      </div>
    </>
  )
}
